import { render, staticRenderFns } from "./spinner.global.vue?vue&type=template&id=063199ee&functional=true&"
import script from "./spinner.global.vue?vue&type=script&lang=js&"
export * from "./spinner.global.vue?vue&type=script&lang=js&"
import style0 from "./spinner.global.vue?vue&type=style&index=0&id=063199ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports